<template>
  <div class="comContent">
    <div class="shop-info-root tab-content new-cls">
      <el-form :model="formIn" ref="formIn" label-width="100px" class="demo-ruleForm">
        <div class="left_topic mb20">售后收货信息</div>
        <el-form-item label="收货人" prop="consignee">
          <el-input v-model="formIn.consignee" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="consigneePhone">
          <el-input v-model.number="formIn.consigneePhone" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="省市区" prop="address">
          <el-input v-model.number="formIn.address" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="收货地址" prop="consigneeAddress">
          <el-input v-model.number="formIn.consigneeAddress" autocomplete="off" disabled></el-input>
        </el-form-item>
        <div class="left_topic mb20">退换货流程</div>
        <el-form-item label="文字说明" prop="changingRefundingInstructions">
          <el-input v-model.number="formIn.changingRefundingInstructions" disabled class="liucheng" autocomplete="off"
            type="textarea" maxlength="2000" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <div class="bottom-btn">
            <el-button type="plain" @click="goBack" size="small">返回</el-button>
            <el-button type="plain" class="fix-four" @click="doUpdateInfo('REJECT')" v-if="pageType == 'audit'"
              size="small">驳回</el-button>
            <el-button type="primary" class="fix-four" @click="doUpdateInfo('PASS')" v-if="pageType == 'audit'"
              size="small">审核通过</el-button>
          </div>
        </el-form-item>
      </el-form>

    </div>

    <el-dialog title="驳回原因" :visible.sync="visible" :lock-scroll="true" width="600px" :before-close="handleClose">
      <el-form ref="formDailog" :inline="true" style="text-align: left" label-width="140px">
        <el-row class="reject-c">
          <el-input v-model="remark" type="textarea" clearable size="small" style="width:100%" placeholder="请填写200字以内驳回原因"
            maxlength="200" show-word-limit />
        </el-row>
      </el-form>
      <div class="btnBox">
        <el-button size="small" @click="handleClose">取消</el-button>
        <el-button type="primary" size="small" @click="rejectSub">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>


const IConst_Small = require("@/assets/public/icon-small.png");
const IConst_See_Icon = require("@/assets/zz/see-icon.png");
const IConst_Del_Icon = require("@/assets/zz/del-icon.png");
const IConst_Add_Icon = require("@/assets/zz/add-icon.png");

import { infoDetail, checkSection } from "@/api/shopmange";

import _ from "lodash";

export default {
  components: {},
  data () {
    return {
      SeeIcon: IConst_See_Icon,
      DelIcon: IConst_Del_Icon,
      AddIcon: IConst_Add_Icon,

      imgType: "",
      IConst_Max_Pic_Count: 5,
      imageUrlList: [],

      shopDetail: null,

      formIn: {
        age: ''
      },
      visible: false,
      shopId: null,
      remark: '',
      pageType: '',
    };
  },
  created () {

  },
  computed: {

  },
  mounted () {
    if (this.$route.query.shopId) {
      this.shopId = this.$route.query.shopId;
      this.doLoadInfo();
    }

    if (this.$route.query.type) {
      this.pageType = this.$route.query.type;
    }
  },
  methods: {
    doUpdateInfo (type) {
      if (type == 'REJECT') {
        this.visible = true;
      }
      if (type == 'PASS') {
        this.$confirm(`确定要审核通过吗?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.passSub();
          })
          .catch(() => { });
      }
    },
    handleClose () {
      this.visible = false;
    },
    passSub () {
      let params = {};
      params.id = this.shopId;
      params.status = 'PASS';
      checkSection(params).then((res) => {
        if (res) {
          this.$message.success('操作成功！')
          this.handleClose();
          this.$router.back(-1);
        }
      }).catch((err) => { })
    },
    rejectSub () {
      if (!this.remark) {
        this.$message.error('请填写驳回原因！')
        return
      }
      let params = {};
      params.id = this.shopId;
      params.checkReason = this.remark;
      params.status = 'NOT_PASS';
      checkSection(params).then((res) => {
        if (res) {
          this.$message.success('操作成功！')
          this.handleClose();
          this.remark = "";
          this.$router.back(-1)
        }
      }).catch((err) => { })
    },

    doLoadInfo () {
      infoDetail(this.shopId).then((data) => {
        if (data) {
          console.log(data, 'data')
          this.shopDetail = data;
          this.formIn = data;
          this.formIn.address = data.provinceName + data.cityName + data.areaName;
          console.log(this.formIn, 'formIn')
        }
      });
    },

    handlePreview (refName) {
      if (this.$refs[refName]) {
        if (this.$refs[refName] instanceof Array) {
          this.$refs[refName][0].showViewer = true;
        } else {
          this.$refs[refName].showViewer = true;
        }
      }
    },
    handleDeleteImage (tag) {
      if (tag === "logo") {
        this.formIn.shopLogo = "";
      }
    },
    goBack () {
      this.$router.back(-1)
    }
  },
};
</script>

<style lang="scss" scoped>
@import "style/index.scss";

::v-deep .liucheng {
  .el-textarea__inner {
    height: 150px;
  }
}

.tab-content {
  height: 100%;
  width: 60%;
  padding-top: 24px;
  margin: auto;
}

.btnBox {
  margin-top: 20px;
}
</style>
